<template>
  <div class="marker-symbol"
       :class="extraClass"
       :style="computedStyle">
    <!-- Gradient via CSS mask -->
    <!-- {{ componentTag }} -->
    <div v-if="hasGradientMask"
         class="marker-image"
         :style="maskedStyle" />

    <!-- Fallback: render img or VSvg directly -->
    <component :is="componentTag" v-else-if="src"
          :src="src"
          :alt="alt || 'check'"
          class="marker-image"
          v-bind="svgBind"
          :style="componentDirectStyle"
          @error="onImgError" />
    <slot v-else />
  </div>
</template>

<script setup lang="ts">
import {computed} from 'vue';
import VSvg from '../../../vendor/VSvg.vue';

const props = defineProps<{
  src?: string | null;
  alt?: string | null;
  styleObj?: Record<string, any>;
  extraClass?: string;
  useSvg?: boolean;
  svgOptions?: Record<string, any> | null;
  gradientStyle?: Record<string, any> | null;
  markerVerticalOffset?: number;
}>();

const componentTag = computed(() => (props.useSvg ? VSvg : 'img'));

const svgBind = computed(() => (props.useSvg ? {options: props.svgOptions || {}} : {}));

const hasGradientMask = computed(() => !!(props.src && props.gradientStyle && (props.gradientStyle as any).background));

const maskedStyle = computed(() => {
  const background = (props.gradientStyle as any)?.background || 'transparent';
  const url = props.src || '';
  return {
    background,
    WebkitMask: `url(${url}) center/contain no-repeat`,
    mask: `url(${url}) center/contain no-repeat`
  } as Record<string, any>;
});

// Для VSvg не применяем gradientStyle напрямую, чтобы не искажать stroke
const componentDirectStyle = computed(() => {
  return props.useSvg ? ({} as any) : (props.gradientStyle || ({} as any));
});

const computedStyle = computed(() => {
  const baseStyle = { ...(props.styleObj || {}) };
  if (props.markerVerticalOffset !== undefined && props.markerVerticalOffset !== 0) {
    baseStyle.transform = `translateY(${props.markerVerticalOffset}px)`;
  }
  return baseStyle;
});

function onImgError(e: Event) {
  if (props.useSvg) return;
  const img = e.target as HTMLImageElement;
  img.src = '/markers/check-1.svg';
  img.onerror = () => {
    img.style.display = 'none';
  };
}
</script>

<style scoped>
.marker-symbol {
  display: flex;
  align-items: center;
  justify-content: center;
  flex-shrink: 0;
}

.marker-image {
  width: 30px;
  height: 30px;
}
</style>
